





















































































































































































































import { Component, Prop, Watch, Mixins } from "vue-property-decorator";
import { ValidationObserver } from "vee-validate";

//Mixins
import HasValidation from "@/mixins/HasValidation";
import BrandMixin from "@/mixins/brandMixin";
import CountriesStore from "@/mixins/constants/countriesStore";

// Enums/Data
import {
  BlueprintFieldsTypes,
  ProvisionFieldTypes
} from "@/data/enums/provisioning";
import { DataModules } from "@/store/modules/data";
import { SemanticTypes } from "@/data/constants";
import { UpmindModuleCodes } from "@/data/enums/upmind";

// Types
import { IBlueprintField } from "@/models/provisioning";

@Component({
  components: {
    "smart-domain-field": () =>
      import("@/modules/web_hosting/components/domains/smartDomainField.vue"),
    "phone-number-field": () =>
      import("@/components/app/global/fields/phoneNumberField.vue")
  }
})
export default class ProvisionField extends Mixins(
  HasValidation,
  BrandMixin,
  CountriesStore
) {
  public declare $refs: {
    focusedField: HTMLFormElement;
    observer: InstanceType<typeof ValidationObserver>;
  };

  // Props

  @Prop({ required: true })
  public value!: any;

  @Prop({ required: true })
  public field!: IBlueprintField;

  @Prop({ default: () => [] })
  public fieldValues!: IBlueprintField;

  @Prop({ required: true })
  public fieldId!: string;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: false })
  public isReadOnly!: boolean;

  @Prop({ default: true })
  public showLabel!: boolean;

  @Prop({ default: ProvisionFieldTypes.PRODUCT_FIELD })
  public type!: ProvisionFieldTypes;

  @Prop({ default: false })
  public noPlaceholder!: boolean;

  @Prop({ default: false })
  public initialFocuse!: boolean;

  @Prop({ default: false })
  public replaceSemanticTypes!: boolean;

  public dataModule = DataModules.PROVISIONING_CATEGORIES;
  public isFetching = false;
  public data: string[] = [];
  public isRequiredIf = false;
  public dateFormValue: Date | null = null;

  public getAsyncData = this.$_.debounce(this.getSuggestions, 500);

  public get formValue() {
    return this.value;
  }

  public set formValue(value) {
    this.$emit("input", value);
  }

  public async created() {
    if (this.isCheckbox && this.value === undefined) {
      this.$emit("input", false);
    }

    if (this.isDate && this.formValue) {
      this.dateFormValue = this.$moment(this.$_.clone(this.formValue)).toDate();
    }

    if (this.initialFocuse) {
      this.$nextTick(() => {
        const field = this.$_.get(this.$refs, "focusedField");
        if (field) {
          field.focus();
        }
      });
    }
  }

  public async getSuggestions() {
    if (
      !this.$userCan("list_provision_configuration_attribute_value_suggestions")
    ) {
      return;
    }

    this.isFetching = true;
    try {
      const results = await this.getAttributeValueSuggestions(this.formValue);
      this.data = [];
      this.$_.forEach(results, result => this.data.push(result));
    } catch (error) {
      this.data = [];
      this.$store.dispatch("api/handleError", error);
    }
    this.isFetching = false;
  }

  public getAttributeValueSuggestions(value: string) {
    return this.$store.dispatch(
      `data/${this.dataModule}/getAttributeValueSuggestions`,
      {
        id: this.$_.get(this.field, "pivot.category_id"),
        attributeId: this.$_.get(this.field, "pivot.attribute_id"),
        ignoreStored: true,
        params: {
          search: value
        }
      }
    );
  }

  public onDateChange(value) {
    this.$set(this, "formValue", this.$moment(value).format("YYYY-MM-DD"));
  }

  public get brandCountry() {
    return this.countries?.find(
      country => country.id === this.brand?.country_id
    );
  }

  public get isProvisionAttribute() {
    return this.type === ProvisionFieldTypes.PRODUCT_ATTRIBUTE;
  }

  public get hasSuggestions() {
    return this.isProvisionAttribute && this.isTextInput;
  }

  public get getLabel() {
    return (
      this.getFieldName +
      `${this.field.required || this.isRequiredIf ? "*" : ""}${
        this.isSlider ? `: ${this.formValue}` : ""
      }`
    );
  }

  public get getFieldName() {
    return this.$_.get(
      this.field,
      "field_label",
      this.$_.get(this.field, "name", "")
    );
  }

  public get rules() {
    const isRequired =
      (this.field.required && this.field.required !== undefined) ||
      this.isRequiredIf;

    return {
      required_phone:
        this.isTelInput && isRequired && !this.isReadOnly
          ? { countryCode: this.brandCountry?.code }
          : false,
      required_number: this.isNumber && isRequired && !this.isReadOnly,
      required:
        !this.isTelInput && !this.isNumber && isRequired && !this.isReadOnly
    };
  }

  public get isRequired() {
    return this.field.required;
  }

  public get isTextInput() {
    return this.field.field_type === BlueprintFieldsTypes.INPUT_TEXT;
  }

  public get isTelInput() {
    return this.field.field_type === BlueprintFieldsTypes.INPUT_TEL;
  }

  public get isPasswordInput() {
    return this.field.field_type === BlueprintFieldsTypes.INPUT_PASSWORD;
  }

  public get isNumber() {
    return this.field.field_type === BlueprintFieldsTypes.INPUT_NUMBER;
  }

  public get isTextarea() {
    return this.field.field_type === BlueprintFieldsTypes.TEXTAREA;
  }

  public get isSelect() {
    return this.field.field_type === BlueprintFieldsTypes.SELECT;
  }

  public get isRadio() {
    return this.field.field_type === BlueprintFieldsTypes.INPUT_RADIO;
  }

  public get isCheckbox() {
    return this.field.field_type === BlueprintFieldsTypes.CHECKBOX;
  }

  public get isSlider() {
    return this.field.field_type === BlueprintFieldsTypes.INPUT_RANGE;
  }

  public get isDate() {
    return this.field.field_type === BlueprintFieldsTypes.INPUT_DATE;
  }

  public get isDateTime() {
    return this.field.field_type === BlueprintFieldsTypes.INPUT_DATETIME;
  }

  public get isSmartDomainField() {
    return (
      this.replaceSemanticTypes &&
      this.field.semantic_type === SemanticTypes.DOMAIN_NAMES &&
      this.$store.getters["org/hasModuleEnabled"](UpmindModuleCodes.WEB_HOSTING)
    );
  }

  @Watch("fieldValues", { deep: true, immediate: true })
  public onFieldValuesChange() {
    const requiredRule = this.$_.find(
      this.field.validation_rules,
      validationRule => validationRule.includes("required_")
    );

    if (!requiredRule) {
      this.isRequiredIf = false;
    }

    if (requiredRule) {
      if (requiredRule.includes("required_without_all:")) {
        this.$set(
          this,
          "isRequiredIf",
          this.$_.every(
            this.getMappedRequiredFields(
              requiredRule.replace("required_without_all:", "").split(",")
            )
          )
        );
      }

      if (requiredRule.includes("required_without:")) {
        this.$set(
          this,
          "isRequiredIf",
          this.$_.some(
            this.getMappedRequiredFields(
              requiredRule.replace("required_without:", "").split(",")
            )
          )
        );
      }

      if (requiredRule.includes("required_with_all:")) {
        this.$set(
          this,
          "isRequiredIf",
          this.$_.every(
            this.getMappedRequiredFields(
              requiredRule.replace("required_with_all:", "").split(","),
              false
            )
          )
        );
      }

      if (requiredRule.includes("required_with:")) {
        this.$set(
          this,
          "isRequiredIf",
          this.$_.some(
            this.getMappedRequiredFields(
              requiredRule.replace("required_with:", "").split(","),
              false
            )
          )
        );
      }
    }
  }

  public getMappedRequiredFields(requiredFields, empty = true) {
    return this.$_.map(requiredFields, requiredFieldName => {
      return empty
        ? this.fieldValues[requiredFieldName] === "" ||
            this.fieldValues[requiredFieldName] === undefined
        : this.fieldValues[requiredFieldName] !== "" &&
            this.fieldValues[requiredFieldName] !== undefined;
    });
  }
}
